"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CID_10 = void 0;
var CID_10 = exports.CID_10 = 'cid10';